// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgToys = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3.5a1.5 1.5 0 0 0-.331 2.963 7.033 7.033 0 0 1 1.83-1.526A1.5 1.5 0 0 0 5 3.5Zm2.921.814A3.001 3.001 0 1 0 3.8 7.75a7 7 0 1 0 12.403 0 3 3 0 1 0-4.123-3.436A6.997 6.997 0 0 0 10 4c-.724 0-1.422.11-2.079.314Zm5.58.623c.694.402 1.313.92 1.83 1.526a1.5 1.5 0 1 0-1.83-1.526Zm.886 2.745A5.491 5.491 0 0 0 10 5.5a5.491 5.491 0 0 0-4.413 2.217 5.5 5.5 0 1 0 8.8-.035ZM7.75 8a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 7.75 8Zm4.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75Zm-3.915 5.079.003.002.024.01.105.048c.094.04.23.095.395.15.338.112.751.211 1.138.211.387 0 .8-.099 1.138-.211a5.195 5.195 0 0 0 .5-.197l.024-.011.003-.002m-3.33 0a.75.75 0 0 0-.67 1.342l.317-.635-.317.635.002.001.005.002.013.007.043.02a6.616 6.616 0 0 0 .66.26C8.8 14.85 9.387 15 10 15c.613 0 1.2-.151 1.612-.289a6.623 6.623 0 0 0 .66-.26l.043-.02.013-.007.005-.002h.001s.001-.001-.309-.622l.31.621a.751.751 0 0 0-.67-1.342"
    />
  </svg>
)

export default SvgToys
